/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './ListItem.scss'
import React from 'react'

/*
props {
  isOpen: FoldableListと合わせて使う. 何も設定しない場合は `true`.
}
*/
function ListItem(props) {
  const className = props.className || ''
  const isOpen = props.isOpen === undefined ? true : props.isOpen
  const visible = isOpen ? 'ListItem--visible' : ''

  return (
    <li className={`ListItem ${visible} ${className}`} onClick={props.onClick}>
      {props.children}
    </li>
  )
}

export default ListItem
